import { validateTidalLicense } from "../../base/index.js";
import { upperCase } from "./utils/upperCase.js";
function sentenceCase(source) {
  return source.toLowerCase().replace(/(^\w)|\.\s+(\w)/gm, upperCase);
}
validateTidalLicense();
export {
  sentenceCase
};
//# sourceMappingURL=sentenceCase.js.map
